import gql from 'graphql-tag';

export default gql`
  query flightMarket($origin: IataCode!, $destination: IataCode!, $operatedBy: [String]) {
    flightMarket(origin: $origin, destination: $destination, operatedBy: $operatedBy) {
      type
      calendar {
        availableFrom
        availableUntil
        departingDates {
          date
          operatedBy
        }
        returningDates {
          date
          operatedBy
        }
      }
    }
  }
`;
